(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bedlock-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    const variantsNode = document.querySelector('[data-mzl-variants]');
    if (variantsNode && !variantsNode.dataset.ready) {
      variantsNode.dataset.ready = 'true';
      let variants = [];
      try { variants = JSON.parse(variantsNode.textContent); } catch (error) { variants = []; }
      const variantDisplayNode = document.querySelector('[data-mzl-variant-display]');
      let variantDisplay = [];
      try { variantDisplay = variantDisplayNode ? JSON.parse(variantDisplayNode.textContent) : []; } catch (error) { variantDisplay = []; }
      const radios = Array.from(document.querySelectorAll('.main-product-section .quantity-breaks-container input[type="radio"]'));
      radios.forEach((radio, index) => {
        const variant = variants.find(item => Array.isArray(item.options) && item.options[0] === radio.value) || variants[index];
        const label = document.querySelector('label[for="' + CSS.escape(radio.id) + '"]');
        const badge = label?.querySelector('.quantity-break__badge');
        if (badge && variant && Number(variant.compare_at_price) > Number(variant.price)) {
          const saving = Math.round((Number(variant.compare_at_price) - Number(variant.price)) / Number(variant.compare_at_price) * 100);
          badge.textContent = 'SAVE ' + saving + '%';
          badge.hidden = false;
        } else if (badge) {
          badge.hidden = true;
        }
        if (index === 1 && label && !label.querySelector('.mzl-selling-fast')) {
          const marker = document.createElement('span');
          marker.className = 'mzl-selling-fast';
          const fire = document.createElement('span');
          fire.className = 'mzl-fire';
          fire.setAttribute('aria-hidden', 'true');
          fire.textContent = '🔥';
          marker.append(fire, document.createTextNode(' ' + variantsNode.dataset.sellingText));
          (label.querySelector('.quantity-break__label') || label).append(marker);
        }
      });
    }

    const benefitCards = Array.from(document.querySelectorAll('.main-product-section .mzl-purchase-benefit'));
    const benefitContent = [
      {label:'Higher sleep quality', icon:'<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M24 21.5A10 10 0 0 1 10.5 8 10.5 10.5 0 1 0 24 21.5Z"/><path d="m22 7 .8 2.2L25 10l-2.2.8L22 13l-.8-2.2L19 10l2.2-.8L22 7Z"/></svg>'},
      {label:'Premium PVC', icon:'<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M16 3 27 9v14l-11 6L5 23V9l11-6Z"/><path d="m10 16 4 4 8-9"/></svg>'},
      {label:'Loved by 200k+ families', icon:'<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="11" cy="11" r="3"/><circle cx="21" cy="11" r="3"/><path d="M5 25c0-5 3-8 6-8s6 3 6 8M15 25c0-5 3-8 6-8s6 3 6 8"/><path d="M16 15c2-2 5 1 0 5-5-4-2-7 0-5Z"/></svg>'},
      {label:'Secure grip, proven', icon:'<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="7" y="14" width="18" height="14" rx="2"/><path d="M11 14V9a5 5 0 0 1 10 0v5"/><path d="m12 21 3 3 6-7"/></svg>'}
    ];
    benefitCards.forEach((card, index) => {
      const content = benefitContent[index];
      if (!content) return;
      card.classList.add('mzl-benefit-card', 'mzl-benefit-card--' + (index + 1));
      card.innerHTML = content.icon + '<span>' + content.label + '</span>';
    });
    const returnSeal = root.querySelector('.mzl-guarantee-number span');
    if (returnSeal) returnSeal.textContent = 'Days Return';
    root.querySelectorAll('[data-mzl-carousel]').forEach(carousel => {
      if (carousel.dataset.ready) return;
      carousel.dataset.ready = 'true';
      const track = carousel.querySelector('[data-mzl-track]');
      const items = Array.from(track.children);
      const controls = carousel.querySelector('[data-mzl-controls]');
      if (items.length < 2 || !controls) return;
      controls.hidden = false;
      const previous = controls.querySelector('[data-mzl-prev]');
      const next = controls.querySelector('[data-mzl-next]');
      const count = controls.querySelector('[data-mzl-count]');
      const update = () => {
        const step = items[1].offsetLeft - items[0].offsetLeft;
        const index = Math.round(track.scrollLeft / step);
        count.textContent = `${Math.min(index + 1, items.length)} / ${items.length}`;
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      const move = direction => track.scrollBy({left: direction * (items[1].offsetLeft - items[0].offsetLeft), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
      });
      track.addEventListener('scroll', update, {passive:true});
      new ResizeObserver(update).observe(track);
      update();
    });

    root.querySelectorAll('[data-mzl-cart]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const nativeTrigger = document.querySelector('#cart-icon-bubble, .header__icon--cart');
        if (nativeTrigger) { nativeTrigger.click(); return; }
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;
        const closeDrawer = () => {
          drawer.classList.remove('active');
          document.body.classList.remove('overflow-hidden');
        };
        drawer.close = closeDrawer;
        drawer.classList.add('active');
        document.body.classList.add('overflow-hidden');
        drawer.querySelector('.drawer__inner')?.focus();
        drawer.querySelectorAll('.drawer__close, #CartDrawer-Overlay').forEach(close => {
          if (close.dataset.mzlReady) return;
          close.dataset.mzlReady = 'true';
          close.addEventListener('click', closeDrawer);
        });
      });
    });
    root.querySelectorAll('[data-mzl-sticky-submit]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const nativeButton = document.querySelector('.main-product-section .product-form__submit, [id^="ProductSubmitButton-"]');
      if (!nativeButton) { button.disabled = true; return; }
      const stickyBar = button.closest('[data-mzl-sticky-buy]');
      const stickyVariant = stickyBar?.querySelector('[data-mzl-sticky-variant]');
      const stickySelection = stickyBar?.querySelector('[data-mzl-sticky-selection]');
      const stickyPrice = stickyBar?.querySelector('[data-mzl-sticky-price]');
      const getNativeVariantInput = () => document.querySelector('.main-product-section form[action*="/cart/add"] input[name="id"]');
      const nativeVariantInput = getNativeVariantInput();
      const sync = () => {
        button.disabled = nativeButton.disabled;
        const currentId = new URLSearchParams(window.location.search).get('variant') || getNativeVariantInput()?.value || stickyVariant?.value;
        if (stickyVariant && currentId) stickyVariant.value = currentId;
        let displayVariant = null;
        try {
          const currentDisplayNode = document.querySelector('[data-mzl-variant-display]');
          const currentDisplayVariants = currentDisplayNode ? JSON.parse(currentDisplayNode.textContent) : [];
          displayVariant = currentDisplayVariants.find(item => String(item.id) === String(currentId));
        } catch (error) { displayVariant = null; }
        if (stickySelection && displayVariant) stickySelection.textContent = displayVariant.title;
        if (stickyPrice && displayVariant) stickyPrice.textContent = displayVariant.price;
      };
      stickyVariant?.addEventListener('change', () => {
        const variant = variants.find(item => String(item.id) === stickyVariant.value);
        const radio = variant ? Array.from(document.querySelectorAll('.main-product-section .quantity-breaks-container input[type="radio"]')).find(item => item.value === variant.options?.[0]) : null;
        if (radio) radio.click();
        else {
          const liveVariantInput = getNativeVariantInput();
          if (liveVariantInput) {
            liveVariantInput.value = stickyVariant.value;
            liveVariantInput.dispatchEvent(new Event('change', {bubbles:true}));
          }
        }
      });
      button.addEventListener('click', () => nativeButton.click());
      new MutationObserver(sync).observe(nativeButton, {attributes:true, attributeFilter:['disabled']});
      if (nativeVariantInput) new MutationObserver(sync).observe(nativeVariantInput, {attributes:true, attributeFilter:['value']});
      document.addEventListener('change', event => {
        if (event.target.matches('.main-product-section input[type="radio"], .main-product-section select')) {
          requestAnimationFrame(() => requestAnimationFrame(sync));
        }
      });
      const syncInterval = window.setInterval(sync, 250);
      window.addEventListener('pagehide', () => window.clearInterval(syncInterval), {once:true});
      sync();
    });
    root.querySelectorAll('[data-mzl-section] video').forEach(video => {
      if (video.dataset.mzlReady) return;
      video.dataset.mzlReady = 'true';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) { video.autoplay = false; video.pause(); return; }
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) video.play().catch(() => {});
          else video.pause();
        });
      }, { threshold: 0.3 });
      observer.observe(video);
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();


  /* Independent sticky variant synchronizer for themes that replace product forms. */
  (() => {
    const startStickySync = () => {
      const displayNode = document.querySelector('[data-mzl-variant-display]');
      const stickyBar = document.querySelector('[data-mzl-sticky-buy]');
      if (!displayNode || !stickyBar || stickyBar.dataset.variantSyncReady) return;
      stickyBar.dataset.variantSyncReady = 'true';
      let displayVariants = [];
      try { displayVariants = JSON.parse(displayNode.textContent); } catch (error) { return; }
      const renderStickyVariant = () => {
        const variantId = new URLSearchParams(window.location.search).get('variant');
        const selected = displayVariants.find(item => String(item.id) === String(variantId));
        if (!selected) return;
        const selection = stickyBar.querySelector('[data-mzl-sticky-selection]');
        const price = stickyBar.querySelector('[data-mzl-sticky-price]');
        const selector = stickyBar.querySelector('[data-mzl-sticky-variant]');
        if (selection) selection.textContent = selected.title;
        if (price) price.textContent = selected.price;
        if (selector) selector.value = String(selected.id);
      };
      renderStickyVariant();
      window.setInterval(renderStickyVariant, 200);
      document.addEventListener('change', event => {
        if (event.target.matches('.main-product-section input[type="radio"], .main-product-section select')) {
          window.setTimeout(renderStickyVariant, 50);
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startStickySync, {once:true});
    else startStickySync();
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marzeluvo-product-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mlp]').forEach((root)=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const slides=[...root.querySelectorAll('[data-slide]')];
  const thumbs=[...root.querySelectorAll('[data-thumb]')];
  const show=(index)=>{slides.forEach((el,i)=>el.classList.toggle('is-active',i===index));thumbs.forEach((el,i)=>el.classList.toggle('is-active',i===index));};
  thumbs.forEach((button)=>button.addEventListener('click',()=>show(Number(button.dataset.thumb))));
  const select=root.querySelector('[data-variant-select]');
  const price=root.querySelector('[data-price]');
  const compare=root.querySelector('[data-compare]');
  const submit=root.querySelector('[data-submit]');
  const submitLabel=root.querySelector('[data-submit-label]');
  const stickyPrice=root.querySelector('[data-sticky-price]');
  select?.addEventListener('change',()=>{
    const option=select.selectedOptions[0];
    const available=option.dataset.available==='true';
    price.textContent=option.dataset.price;
    stickyPrice.textContent=option.dataset.price;
    compare.textContent=option.dataset.compare;
    compare.hidden=!option.dataset.compare||option.dataset.compare===option.dataset.price;
    submit.disabled=!available;
    submitLabel.textContent=available?root.dataset.addLabel:root.dataset.soldLabel;
    const mediaIndex=slides.findIndex((slide)=>slide.dataset.mediaId===option.dataset.mediaId);
    if(mediaIndex>=0)show(mediaIndex);
    const url=new URL(window.location.href);
    url.searchParams.set('variant',option.value);
    window.history.replaceState({},'',url);
  });
  const quantity=root.querySelector('[data-quantity]');
  root.querySelector('[data-minus]')?.addEventListener('click',()=>quantity.value=Math.max(1,Number(quantity.value)-1));
  root.querySelector('[data-plus]')?.addEventListener('click',()=>quantity.value=Number(quantity.value)+1);
  const purchase=root.querySelector('.mlp__purchase');
  const sticky=root.querySelector('[data-sticky]');
  if(purchase&&sticky)new IntersectionObserver(([entry])=>sticky.hidden=entry.isIntersecting,{threshold:.08}).observe(purchase);
  root.querySelector('[data-sticky-submit]')?.addEventListener('click',()=>submit?.click());
});

  } catch(e) { console.error(e); }
})();
})();
